// Free usage policy: Free testa skills elegíveis até N vezes por conta.
// O bloqueio é POR SKILL (capability), nunca global.
//
// Enforcement adicional continua nos engines/backend (ex.: limite mensal da Sensi).
// Este contador é a camada de UX do agente — persistido via gphConversationStore.

import { FREE_LIMIT_DEFAULT } from './gphCapabilityRegistry';

export const getFreeLimit = (capability) => {
  if (!capability) return 0;
  if (capability.requiresPlan !== 'free_limited') return 0;
  const limit = Number(capability.freeLimit);
  return Number.isFinite(limit) && limit > 0 ? limit : FREE_LIMIT_DEFAULT;
};

export const getUsageCount = (usage = {}, capabilityId = '') => {
  const count = Number(usage?.[capabilityId]);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

export const isFreeLimitReached = (usage = {}, capability) => {
  const limit = getFreeLimit(capability);
  if (limit <= 0) return false;
  return getUsageCount(usage, capability.capabilityId) >= limit;
};

export const registerUse = (usage = {}, capabilityId = '') => ({
  ...usage,
  [capabilityId]: getUsageCount(usage, capabilityId) + 1
});

export const describeUsage = (usage = {}, capability) => {
  const limit = getFreeLimit(capability);
  if (limit <= 0) return null;
  const count = getUsageCount(usage, capability.capabilityId);
  return { count, limit, remaining: Math.max(0, limit - count) };
};

export default isFreeLimitReached;
